<span [ngbPopover]="params.value" container="body" popoverClass="CXoneMgtPopover" triggers="mouseenter:mouseleave" placement="bottom-left top-left"
    [disablePopover]="params.value === null || params.value === ''" class="textContent" [innerHTML]="params.valueFormatted | boldText:searchFilter:minSearchLength">
</span>
